<template>
  <div class="p-4 overflow-auto h-100" style="padding-bottom: 200px !important">
    <time-line class="mt-4 custom-time-line mb-5 pb-5">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line__item rounded">
          <div id="main-info" class="row">
            <div class="col-6 d-flex flex-column custom-time-line__date">
              <span class="color-black font-weight-bold font-12">
                {{ item.date | date }}
              </span>
              <span class="color-gray-13 font-12">{{ item.date | hour }}</span>
            </div>
            <div class="col-12 bg-white rounded d-flex">
              <span
                class="fa-stack fa-1x color-orange-light-2 font-15 mr-1 custom-time-line__icon"
              >
                <em class="fal fa-circle fa-stack-2x" />
                <em
                  class="fa-stack-1x fa-inverse color-orange-light-2"
                  :class="icon(item.eventId)"
                />
              </span>
              <div class="pb-3">
                <div class="color-gray-7 font-weight-bold font-14 p-2">
                  {{ item.eventDescription }}
                </div>
                <div>
                  <div class="d-flex align-items-center">
                    <em
                      :class="`fa fa-circle font-12 color-${statusColor(
                        item.eventStatusId
                      )}`"
                    />
                    <div class="color-gray-18 font-12 ml-2">
                      {{ item.eventStatusName }}
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <div class="mb-3">
                    <div class="color-gray-18 font-12">
                      {{ $t('lblUserName.Text') }}:
                    </div>
                    <div class="color-black font-12">
                      {{ item.userName }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="color-gray-18 font-12">
                      {{ $t('lbltxtComment.text') }}:
                    </div>
                    <div class="color-gray-7 font-12">
                      {{ item.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from 'timeline';
import alertMixin from 'utils/mixins/alert.mixin';
import { getTrackingEntries as _getTrackingEntries } from '@/services/app.api';
import { requestStatusColor } from '@/utils/constants/requestStatus';
import { eventStatusIcon } from '@/utils/constants/eventStatus.js';

export default {
  name: 'History',
  mixins: [alertMixin],
  components: {
    TimeLine,
    TimeLineItem,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    requestNumber() {
      return this.itemModel?.requestNumber;
    },
    statusColor() {
      return (eventStatusId) => requestStatusColor[eventStatusId];
    },
    icon() {
      return (eventId) => eventStatusIcon[eventId];
    },
  },
  async mounted() {
    if (this.requestNumber) {
      await this.getComments(this.requestNumber);
    }
  },
  methods: {
    async getComments(requestNumber) {
      this.items = (await _getTrackingEntries(requestNumber)).data;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-time-line {
  &__item ::v-deep {
    .timeline__content {
      &--inner {
        padding: unset !important;
        background: unset !important;
        &::after {
          top: 0px !important;
        }
      }
      &::before {
        left: -45px;
      }
      &::after {
        top: 0px;
        left: -50px;
      }
    }
    .mr-3 {
      margin-right: 0px !important;
      .w-date-fixed {
        width: unset !important;
      }
    }
  }
  &__date {
    margin-top: -4px;
    margin-bottom: 8px;
    margin-left: -30px;
  }
  &__icon {
    position: absolute;
    left: -13px;
    top: 3px;
    background: #fff;
    border-radius: 100%;
    width: 30px;
  }
}
</style>
